import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePartner } from '../contexts/PartnerContext';

interface PaymentsAccessGuardProps {
  children: React.ReactNode;
}

const PaymentsAccessGuard: React.FC<PaymentsAccessGuardProps> = ({ children }) => {
  const { partner, loading } = usePartner();

  // Показываем загрузку, пока не получим данные партнера
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 text-white p-6">
        <div className="max-w-7xl mx-auto">
          <div className="animate-pulse">
            <div className="h-8 bg-gray-800 rounded w-1/4 mb-6"></div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-32 bg-gray-800 rounded"></div>
              ))}
            </div>
            <div className="h-96 bg-gray-800 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  // Если доступ разрешен, показываем содержимое
  return <>{children}</>;
};

export default PaymentsAccessGuard; 